import heartbeat from './heartbeat.vue'
export default function(Vue) {
	const Constructor = Vue.extend(heartbeat);
	const Instance = new Constructor();
	Instance.$mount();
	document.body.appendChild(Instance.$el);
	Vue.prototype.$heartbeat = ({ title, content }) => {
		Instance.isDialog = true;
		Instance.title = title;
		Instance.content = content;
	}
}